<template>
  <div class="w-full">
    <RadialProgress
      style="margin: auto"
      :diameter="250"
      :completed-steps="parseInt(companyAdminStore.statistics?.total_amount)"
      :total-steps="parseInt(companyAdminStore.company?.companyGoal)"
      innerStrokeColor="#E6E9EE"
      :startColor="donorStore.mainColor"
      :stopColor="donorStore.mainColor"
      strokeWidth="22"
      innerStrokeWidth="22"
    >
      <div class="centerInRadial flex">
        <div class="content">
          <div
            class="met"
            v-if="
              companyAdminStore.statistics?.total_amount >= companyAdminStore.company?.companyGoal &&
              companyAdminStore.company?.companyGoal > 0
            "
          >
            <div class="svg"><PartyHorn width="15" />GOAL MET!</div>
          </div>
          <p
            v-else
            class="text-center text-[30px] font-bold mb-0"
            data-test="total-amount"
          >
            {{ filters.formatMoney(companyAdminStore.statistics?.total_amount) }}
          </p>
          <div
            class="text-center"
            data-test="company-goal"
          >
            RAISED OF
            {{
              companyAdminStore.company?.companyGoal
                ? filters.formatMoney(parseInt(companyAdminStore.company?.companyGoal))
                : '0'
            }}
          </div>
          <div
            class="text-center text-[13px]"
            data-test="total-donations"
          >
            {{ companyAdminStore.statistics?.total_donations }} DONATIONS
          </div>
        </div>
      </div>
    </RadialProgress>
    <div
      class="flex flex-row justify-around items-center w-[340px] pt-2"
      style="margin: auto"
    >
      <div class="flex-1 text-center">
        <div class="font-bold text-[14px]">CURRENT EMPLOYEES</div>
        <div
          class="font-bold text-[24px]"
          data-test="total-employees"
        >
          {{ companyAdminStore.statistics?.total_employees }}
        </div>
      </div>
      <div class="flex-1 text-center">
        <div class="font-bold text-[14px]">AVERAGE DONATION</div>
        <div
          class="font-bold text-[24px]"
          data-test="average-donation"
        >
          {{
            filters.formatMoney(
              companyAdminStore.statistics?.total_amount / companyAdminStore.statistics?.total_employees,
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import filters from '@/helpers/filters';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import RadialProgress from 'vue3-radial-progress';

const donorStore = useDonorStore();
const companyAdminStore = useCompanyAdminStore();
</script>
